import { Controller } from '@hotwired/stimulus';

export default class PromoCodeController extends Controller {
  static targets = ['link', 'promoCodeBlock', 'promoCodeInput', 'feedback'];
  static values = {
    verificationUrl: String,
    verificationSuccessFeedback: String,
    verificationErrorFeedback: String,
    newInvestorsFeedback: String,
  };

  connect() {}

  setInputAsNeutral() {
    this.promoCodeInputTarget.classList.remove('border-danger', 'text-danger');
    this.promoCodeInputTarget.classList.remove(
      'border-success',
      'text-success'
    );
    this.feedbackTarget.classList.add('d-none');
    this.feedbackTarget.classList.remove('text-danger', 'text-success');
  }

  setInputAsValid() {
    this.promoCodeInputTarget.classList.remove('border-danger', 'text-danger');
    this.promoCodeInputTarget.classList.add('border-success', 'text-success');
    this.feedbackTarget.textContent = this.verificationSuccessFeedbackValue;
    this.feedbackTarget.classList.remove('d-none', 'text-danger');
    this.feedbackTarget.classList.add('text-success');
  }

  setInputAsInvalid(message) {
    this.promoCodeInputTarget.classList.remove(
      'border-success',
      'text-success'
    );
    this.promoCodeInputTarget.classList.add('border-danger', 'text-danger');
    this.feedbackTarget.textContent = message;
    this.feedbackTarget.classList.remove('d-none', 'text-success');
    this.feedbackTarget.classList.add('text-danger');
  }

  displayPromoCode(event) {
    event.preventDefault();
    this.linkTarget.classList.add('d-none');
    this.promoCodeBlockTarget.classList.remove('d-none');
    this.promoCodeBlockTarget.classList.add('d-md-flex');
  }

  verifyPromoCode() {
    if (!this.promoCodeInputTarget.value.length) return;

    const verificationUrlEndpoint = new URL(this.verificationUrlValue);
    verificationUrlEndpoint.searchParams.append(
      'code',
      this.promoCodeInputTarget.value
    );

    fetch(verificationUrlEndpoint, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');

        return response.json();
      })
      .then((data) => {
        if (this.promoCodeInputTarget.value.length <= 3) {
          this.setInputAsNeutral();
        } else if (data.status === 'valid') {
          this.setInputAsValid();
        } else if (data.status === 'only_for_new_investors') {
          this.setInputAsInvalid(this.newInvestorsFeedbackValue);
        } else {
          this.setInputAsInvalid(this.verificationErrorFeedbackValue);
        }
      });
  }
}
